<div (click)="$event.stopPropagation()">
  <button mat-menu-item class="h-50">
    <mat-icon *ngIf="this.icon" class="mr-2"> tonality </mat-icon>

    <span class="text">
      {{ 'map.opacity_slider.opacity' | translate }}
    </span>
    <mat-slider
      [max]="1"
      [min]="0"
      [step]="0.01"
      name="opacity"
      ngDefaultControl
      [(ngModel)]="value"
      (input)="onSliderChange($event)"
      class="no-vertical-padding"
    >
      <input matSliderThumb [value]="value" />
    </mat-slider>
  </button>
</div>
